/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InstallCloudflareWorkerMutationVariables = GraphQL.Exact<{
  apiToken: GraphQL.Scalars['String']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type InstallCloudflareWorkerMutation = { readonly __typename?: 'Mutation', readonly InstallCloudflareWorker: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly isLogFileAnalysisEnabled: boolean } | null } } };


export const InstallCloudflareWorkerDocument = gql`
    mutation InstallCloudflareWorker($apiToken: String!, $websiteId: WebsiteId!) {
  InstallCloudflareWorker(cloudflareApiToken: $apiToken, websiteId: $websiteId) {
    query {
      website(id: $websiteId) {
        id
        isLogFileAnalysisEnabled
      }
    }
  }
}
    `;
export type InstallCloudflareWorkerMutationFn = Apollo.MutationFunction<InstallCloudflareWorkerMutation, InstallCloudflareWorkerMutationVariables>;

/**
 * __useInstallCloudflareWorkerMutation__
 *
 * To run a mutation, you first call `useInstallCloudflareWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallCloudflareWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installCloudflareWorkerMutation, { data, loading, error }] = useInstallCloudflareWorkerMutation({
 *   variables: {
 *      apiToken: // value for 'apiToken'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useInstallCloudflareWorkerMutation(baseOptions?: Apollo.MutationHookOptions<InstallCloudflareWorkerMutation, InstallCloudflareWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallCloudflareWorkerMutation, InstallCloudflareWorkerMutationVariables>(InstallCloudflareWorkerDocument, options);
      }
export type InstallCloudflareWorkerMutationHookResult = ReturnType<typeof useInstallCloudflareWorkerMutation>;
export type InstallCloudflareWorkerMutationResult = Apollo.MutationResult<InstallCloudflareWorkerMutation>;
export type InstallCloudflareWorkerMutationOptions = Apollo.BaseMutationOptions<InstallCloudflareWorkerMutation, InstallCloudflareWorkerMutationVariables>;